import React from "react";
import { Theme } from "@tvg/fuse/theme";
import { GridContainer, GridItem, GridRow } from "@tvg/fuse/grid";
import type { Brand } from "../../../types/brand";
import type { TransformedBrandConfig } from "../../../types/amplience";

import CreditInfoSection from "../common/CreditInfoSection/CreditInfoSection";
import LinkSection from "./LinkSection/LinkSection";
import SocialSection from "./Social/SocialSection";
import AppSection from "./DownloadApp/DownloadApp";
// import SponsorsComponent from "./Sponsor/SponsorComponent";
import CopyrightSection from "../common/CopyrightSection/CopyrightComponent";

import styles from "./complex-footer.module.css";

export interface AppProps {
  brand: Brand;
  /** Footer links from Amplience (optional, falls back to static JSON) */
  footerLinks?: TransformedBrandConfig;
}

const Footer: React.FC<AppProps> = ({ brand, footerLinks }: AppProps) => {
  return (
    <>
      <Theme brand={brand} />

      <CreditInfoSection brand={brand} />

      <GridContainer
        className={`${styles.footer__container} footer__container`}
      >
        <GridRow className={`${styles.footer__row} footer__row`}>
          <GridItem className={`${styles.footer__item} footer__item`} xxs={12}>
            <LinkSection brand={brand} footerLinks={footerLinks} />
          </GridItem>
        </GridRow>

        <GridRow className={`${styles.footer__appSocialRow} footer__row`}>
          {brand !== "veryireland" && (
            <GridItem
              className={`${styles.footer__item} footer__item`}
              xxs={12}
              l={6}
            >
              <AppSection brand={brand} />
            </GridItem>
          )}

          <GridItem
            className={`${styles.footer__item} footer__item`}
            xxs={12}
            l={6}
          >
            <SocialSection brand={brand} />
          </GridItem>
        </GridRow>

        {/* {brand === "veryireland" && (
          <GridRow className={`${styles.footer__row} footer__row`}>
            <GridItem
              className={`${styles.footer__item} footer__item`}
              xxs={12}
            >
              <SponsorsComponent brand={brand} />
            </GridItem>
          </GridRow>
        )} */}

        <GridRow className={`${styles.footer__row} footer__row`}>
          <GridItem className={`${styles.footer__item} footer__item`} xxs={12}>
            <CopyrightSection brand={brand} />
          </GridItem>
        </GridRow>
      </GridContainer>
    </>
  );
};

export default Footer;
